var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCokkie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20.375 17.5l-1.45-1.45q.45-.775.725-1.662T20 12.55q-1.25-.55-1.962-1.5t-.963-2.125q-1.925-.275-3.3-1.65t-1.7-3.3q-1.225-.05-2.25.25t-1.9.825L6.5 3.625q1.525-1.05 3.437-1.463t4.138.038q-.225 1.125.15 2.113t1.125 1.662t1.775.925t2.15-.125q-.775 1.725.275 2.95T21.95 11q.2 1.8-.238 3.45t-1.337 3.05M8.5 15q-.625 0-1.062-.437T7 13.5t.438-1.062T8.5 12t1.063.438T10 13.5t-.437 1.063T8.5 15m11.975 8.3l-2.95-2.95q-1.2.8-2.587 1.225T12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12q0-1.55.425-2.937T3.65 6.475L.675 3.5L2.1 2.075l19.8 19.8zM12 20q1.125 0 2.138-.3t1.912-.825L5.125 7.95q-.525.9-.825 1.912T4 12q0 3.325 2.338 5.663T12 20m1.975-10.025"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCokkie);
export default __webpack_public_path__ + "static/media/Cokkie.d242cb288448983afa6acf91eb772b5f.svg";
export { ForwardRef as ReactComponent };